import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { store } from './store';
import Wrappers from './Wrappers';
import App from './App';
import Routes from './routes';
import '@hero/branding/font/gilroy.css';
import './index.css';
import { Toaster } from 'sonner';

declare global {
    interface Window {
        analytics: SegmentAnalytics.AnalyticsJS;
    }
}

// @ts-expect-error stub analytics with a falsy value before Segment loads
window.analytics = false;

const AppShell: React.FC = () => (
    <>
        <App />
        <Routes />
        <Toaster position="bottom-center" richColors />
    </>
);

const router = createBrowserRouter([
    {
        path: '*',
        element: <AppShell />
    }
]);

const container = document.getElementById('app');
const root = createRoot(container!);
const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 0 } } });

root.render(
    <Wrappers store={store}>
        <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
        </QueryClientProvider>
    </Wrappers>
);
